var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.36,14.64l5.52-5.52,.07-.07,4.12-4.12-1.41-1.41-3.29,3.29c-1.1-.26-2.22-.4-3.37-.4-4.19,0-8.2,1.8-11.01,4.93v1.34c1.39,1.54,3.07,2.76,4.91,3.6l-2.39,2.39,1.41,1.41,4.7-4.7h0l.73-.73Zm-2.93,.1c-1.59-.61-3.06-1.54-4.31-2.74,1.55-1.5,3.45-2.56,5.5-3.13-.39,.62-.63,1.35-.63,2.13,0,.89,.3,1.71,.8,2.37l-1.36,1.36Zm15.58-3.41v1.34c-2.81,3.13-6.82,4.93-11.01,4.93-.56,0-1.11-.04-1.66-.11l1.9-1.9c3.22-.06,6.31-1.35,8.64-3.59-.88-.85-1.88-1.54-2.95-2.1l1.47-1.47c1.33,.77,2.56,1.73,3.61,2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeSlash);
export default __webpack_public_path__ + "static/1775731007/media/icon-eye-slash.6892b23b88a50c3af247ac4a799149c8.svg";
export { ForwardRef as ReactComponent };